export default __webpack_public_path__ + "static/media/bg.e22fabe8.webp";